'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindings = exports.template = undefined;
exports.controller = controller;
exports.link = link;

var _heading = require('site/heading.scss');

var styles = _interopRequireWildcard(_heading);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var template = exports.template = '\n<div class="' + styles.line + '"></div>\n<h3 class="' + styles.title + '">{{ctrl.title}}<h3>\n<h1 class="' + styles.body + '">{{ctrl.body}}</h1>\n<div class="' + styles.bar + '"></div>\n';

var bindings = exports.bindings = {
  title: '<',
  body: '<'
};

function controller() {
  var ctrl = this;
  ctrl.id = 'site-heading';
}

function link($scope, $element, $attrs, ctrl) {}

var $directive = {
  scope: {},
  transclude: true
};

if(typeof bindings !== 'undefined') { $directive.bindToController = bindings }

angular.extend($directive, module.exports);

$directive.compile = function($element) {
  if(styles && styles.component) {
    $element.addClass(styles.component)
  }
  if(typeof(compile) === 'function') {
    return compile.apply(this, Array.prototype.slice.call(arguments));
  } else if(typeof(link) === 'function') {
    return {post: link};
  }
};

var $module = require('utils/module-registry').getModule('site');

if (controller) {
  $directive.controller = 'siteHeadingCtrl as ctrl';
  $module.controller('siteHeadingCtrl', controller);
}

$module.directive('siteHeading', function() { return $directive });


/*****************
 ** WEBPACK FOOTER
 ** ./site/heading.directive.js
 ** module id = 30
 ** module chunks = 0
 **/